import { useMemo } from 'react';
export const useWalletAssets = (errors, loading, data) => {
    const assets = useMemo(() => {
        const defaultOptions = {
            fiatAssets: [],
            cryptoAssets: [],
            enabledCryptoAssets: [],
            allAssets: data || [],
            cryptoWithNetwork: [],
        };
        if (!data)
            return defaultOptions;
        return data.reduce((acc, item) => {
            if (item.isCrypto) {
                acc.cryptoAssets.push(item);
                if (item.isDisabled !== null && !item.isDisabled) {
                    acc.enabledCryptoAssets.push(item);
                    if (item.hasNetworks) {
                        acc.cryptoWithNetwork?.push(item);
                    }
                }
            }
            else {
                acc.fiatAssets.push(item);
            }
            return acc;
        }, defaultOptions);
    }, [data]);
    return { assets, errors, loading };
};
//# sourceMappingURL=useWalletAssets.js.map